import { render } from "./WalletButton.vue?vue&type=template&id=0ced410b&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=0ced410b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__